var _ = require('underscore');
module.exports = function(data){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';
 if (data.show_overlay) { 
__p+='\n    <div class="dialog-overlay"></div>\n';
 } 
__p+='\n\n<div class="dialog-box">\n\n    <section class="dialog-section dialog-head">\n        <div class="dialog-title">'+
((__t=( data.title ))==null?'':_.escape(__t))+
'</div>\n        ';
 if (data.close_button) { 
__p+='\n            <div class="dialog-close glyph-center glyph-close"></div>\n        ';
 } 
__p+='\n        ';
 if (data.glyph) { 
__p+='\n            <div class="dialog-glyph glyph-center glyph-'+
((__t=( data.glyph ))==null?'':__t)+
'"></div>\n        ';
 } 
__p+='\n    </section>\n\n    <section class="dialog-section dialog-content"></section>\n\n    ';
 if (data.buttons) { 
__p+='\n        <section class="dialog-section dialog-buttons"></section>\n    ';
 } 
__p+='\n\n</div>\n';
return __p;
};
